import React from "react";
import Banner from "../components/Banner/Banner";

const Home = () => {
  return (
    <div>
      <Banner slideInterval={2000}/>
    </div>
  );
};

export default Home;
